/** @format */

import React, { Fragment } from "react";
import FellowProfileForm from "./FellowProfileForm";
import Profession from "./Profession";
import Learning from "./Learning";
import Education from "./Education";
import Accessibility from "./Accessibility";

const ProfileContent = ({ fellow, activeTab, setActiveTab }) => {
  const data = fellow?.data?.profile;

  return (
    <Fragment>
      {data && (
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-body">
                <div className="profile-tab">
                  <div className="custom-tab-1">
                    <div className="tab-content">
                      {activeTab === "personal" && (
                        <FellowProfileForm
                          setActiveTab={setActiveTab}
                          currentProfile={data}
                        />
                      )}

                      {activeTab === "education" && (
                        <Education
                          setActiveTab={setActiveTab}
                          currentProfile={data}
                        />
                      )}

                      {activeTab === "professional" && (
                        <Profession
                          currentProfile={data}
                          setActiveTab={setActiveTab}
                        />
                      )}

                      {activeTab === "learning" && (
                        <Learning
                          currentProfile={data}
                          setActiveTab={setActiveTab}
                        />
                      )}

                      {activeTab === "accessibility" && (
                        <Accessibility
                          currentProfile={data}
                          setActiveTab={setActiveTab}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ProfileContent;
